import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles(() => ({
  filterButton: {
    marginRight: '10px',
  },
  filterButtonBlue: {
    background: colors.blue94,
    color: colors.blue45,
    '&:hover': {
      background: colors.blue94,
      color: colors.blue45,
    },
    '&:focus': {
      background: colors.blue94,
      color: colors.blue45,
    },
  },
}));
